import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error } from "ui-components/Alert";
import { formRender, initialValues, coReturnCodeValidation } from "./co-return-code-schema";
import { createCOReturnCode } from "services/data.internal.service";
import COReturnCodeInfo from "./components/COReturnCodeInfo";

function AddCOReturnCode() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const createCOReturnCodeMutation = useMutation(createCOReturnCode, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(coReturnCodeValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    createCOReturnCodeMutation.mutate(data, {
      onSuccess: () => {
        reset();
      },
    });
  };
  const createStatus = createCOReturnCodeMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <COReturnCodeInfo {...infoProps} />
        <SubmitButton label="submit" disabled={createStatus}  url="/setup/return-code" />
      </form>
    </Layout>
  );
}

export default AddCOReturnCode;
